import { render, staticRenderFns } from "./ztmyjj-index.vue?vue&type=template&id=38aa1ff6&"
import script from "./ztmyjj-index.vue?vue&type=script&lang=js&"
export * from "./ztmyjj-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports